// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../isFriday/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var isFriday = convertToFP(fn, 1);
export default isFriday;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/isFriday/index.js
// module id = 925
// module chunks = 0